import { ThunkAction } from 'hellospa/redux/types';
import {
  Actions,
  PrepAndSendAction,
  Settings,
  UpdateAccountParams,
} from 'hellospa/page/prep-and-send/data/types';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';

export const setSettings = (
  payload: Partial<Settings>,
): PrepAndSendAction => ({
  type: Actions.UpdateSettings,
  payload,
});

export const updateAccount = (
  values: UpdateAccountParams,
): ThunkAction<void> => async (dispatch, getState, getExtra) => {
  const { updateAccount } = getExtra().appActions;
  const isHelloFax = selectors.isHelloFax(getState());
  const data = await updateAccount(
    values.firstName,
    values.lastName,
    values.alwaysSendMeACopy,
    values.alwaysSendOthersACopy,
    isHelloFax,
  );

  if (data.success) {
    dispatch(setSettings({
      requireSignerInfo: false,
      ...values,
    }));
  }
};
